import React from "react";
import styles from "./NotFound.module.scss";

const NotFound: React.FC = () => {
  return <p className={styles.warning}>PRODUCT NOT FOUND !</p>;
};

export default NotFound;
